
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";

interface TrendChartProps {
  data: number[];
  keyword: string;
}

export const TrendChart = ({ data, keyword }: TrendChartProps) => {
  console.log("TrendChart received data for", keyword, ":", data);
  
  if (!data || data.length === 0) {
    return (
      <div className="text-xs text-gray-500 text-center py-4">
        No trend data available
      </div>
    );
  }

  // Transform data for recharts - ensure we're showing actual variation
  const chartData = data.map((volume, index) => {
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 
                       'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return {
      month: monthNames[index] || `M${index + 1}`,
      volume: volume || 0,
      fullMonth: monthNames[index] || `Month ${index + 1}`
    };
  });

  console.log("TrendChart chartData:", chartData);

  // Find min and max values for better scaling
  const values = chartData.map(d => d.volume).filter(v => v > 0);
  const minValue = Math.min(...values);
  const maxValue = Math.max(...values);
  
  return (
    <div className="mt-4">
      <div className="mb-2">
        <p className="text-sm font-medium text-gray-700">12-Month Search Trend</p>
        <p className="text-xs text-gray-500">
          Monthly search volumes for "{keyword}". Range: {minValue} - {maxValue} searches
        </p>
      </div>
      <ResponsiveContainer width="100%" height={120}>
        <LineChart data={chartData} margin={{ top: 5, right: 5, left: 5, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
          <XAxis 
            dataKey="month" 
            tick={{ fontSize: 10 }}
            axisLine={false}
            tickLine={false}
          />
          <YAxis 
            tick={{ fontSize: 10 }}
            axisLine={false}
            tickLine={false}
            domain={values.length > 0 ? ['dataMin', 'dataMax'] : [0, 100]}
          />
          <Tooltip 
            labelFormatter={(label) => chartData.find(d => d.month === label)?.fullMonth || label}
            formatter={(value) => [value, 'Search Volume']}
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #ccc',
              borderRadius: '4px',
              fontSize: '12px'
            }}
          />
          <Line 
            type="monotone" 
            dataKey="volume" 
            stroke="hsl(var(--primary))" 
            strokeWidth={2}
            dot={{ fill: '#3b82f6', strokeWidth: 2, r: 3 }}
            activeDot={{ r: 5, stroke: '#3b82f6', strokeWidth: 2 }}
            connectNulls={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
